module.exports = __webpack_public_path__ + "b0505cc47f6d535cc832be4a6a85f118.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-LightItalic.svg
// module id = 361
// module chunks = 0